import React, { Component } from "react";

import clsx from "clsx";
import format from "date-fns/format";
import isSameDay from "date-fns/isSameDay";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { createStyles } from "@material-ui/styles";
import { IconButton, TextField, withStyles } from "@material-ui/core";
import DateFnsUtils from '@date-io/date-fns';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDay } from "@fortawesome/free-solid-svg-icons";
import { endOfDay, startOfDay } from "date-fns";


class DaySelectionTool extends Component {
    constructor(props){
        super(props);
        this.state={
            selectedDate: this.props.selectedDate? new Date(this.props.selectedDate): new Date(),           
        }    

    };

    componentDidUpdate(prevProps, prevState){
     
      if(new Date(prevState.selectedDate).getTime()!==new Date(this.props.selectedDate).getTime()){
        this.setState({selectedDate:this.props.selectedDate})
      }

    }

  handleWeekChange = date => {
    this.props.onDateChange(new Date(date));
    this.setState({ selectedDate: new Date(date) });
  };



  renderWrappedWeekDay = (date, selectedDate, dayInCurrentMonth) => {

    const { classes } = this.props;
    let dateClone = new Date(date);
    let selectedDateClone = new Date(selectedDate);

    const dayIsBetween = isSameDay(dateClone, selectedDateClone);

    const wrapperClassName = clsx({
      [classes.highlight]: dayIsBetween && dayInCurrentMonth
    });

    const dayClassName = clsx(classes.day,{
        [classes.nonCurrentMonthDay]: !dayInCurrentMonth,
        [classes.highlightNonCurrentMonthDay]: !dayInCurrentMonth && dayIsBetween,
        [classes.pastDay]: endOfDay(dateClone) < endOfDay(new Date())? true:false

    });

    return (
      <div className={wrapperClassName}>
        <IconButton className={dayClassName}>
          <span> {format(dateClone, "d")} </span>
        </IconButton>
      </div>
    );
  };

  render() {

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <DatePicker
                value={this.state.selectedDate}
                onChange={this.handleWeekChange}
                renderDay={this.renderWrappedWeekDay}
                labelFunc={()=>this.props.renderLabel()}
                minDate={startOfDay(new Date())}
                disableToolbar
                variant="inline"
                autoOk
                TextFieldComponent={(params )=>{
                    return(
                        <TextField
                        {...params}
                        className='registrations_select'
                        style={{cursor:'pointer'}}
                        InputProps={{
                            endAdornment: <FontAwesomeIcon icon={faCalendarDay} color='white' size='sm' />,
                            disableUnderline:true
                        }}   
                    />
                    )
                }}
                helperText=''
                error={false}
            />
        </MuiPickersUtilsProvider>
    );
  }
}

const styles = createStyles(theme => ({
  dayWrapper: {
    position: "relative",
  },
  day: {
    width: 36,
    height: 36,
    fontSize: theme.typography.caption.fontSize,
    margin: "0 2px",
    color: "inherit",
  },
  customDayHighlight: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: "2px",
    right: "2px",
    border: `1px solid #009EDD`,
    borderRadius: "50%",
  },
  pastDay:{
    color: theme.palette.text.disabled,
  },
  nonCurrentMonthDay: {
    color: 'white',
    visibility:'hidden'
  },
  highlightNonCurrentMonthDay: {
    color: "#676767",
  },
  highlight: {
    background: '#009EDD',
    color: theme.palette.common.white,
    border: `1px solid #009EDD`,
    borderRadius:'50%'
  },
}));

export default withStyles(styles)(DaySelectionTool);